export default __webpack_public_path__ + "static/media/packages-error.b6c275d9.jpg";